/**
 * Principal risk LP API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Create specific setting for account on pair.
 */
export interface CreateAccountPairSettingRequest {
  accountId: number;
  lpPair: number;
  /**
   * Formula: 1 = 0.1 BPS = 0.001% = 0.00001.
   */
  takeProfit: number;
  /**
   * In milliseconds
   */
  maxRiskTime: number;
  /**
   * Formula: 1 = 0.1 BPS = 0.001% = 0.00001.
   */
  stopLoss: number;
  minExecVolume: number;
  maxExecVolume: number;
}
